import VueI18nJS from './vue-i18n-js'

export default VueI18nJS
